"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const style = "normal";
const brand = "#EB630B";
const headerTextColor = brand;
const headerBackgroundColor = "#E3CCBC";
const appAccentColor = brand;
const mainInfoPortrait = headerTextColor;
const mainInfoLandscape = headerTextColor;
const colorAppBar = "#E3CCBC"; // light orange
const colorOnAppBar = "#EB630B"; // orange
const colorPrimary = "#E3CCBC";
const colorPrimaryDarker = "#c49473";
const colorPrimaryLighter = "#f9f5f2";
const colorOnPrimary = "#EB630B";
const colorSecondary = "#EB630B";
const colorOnSecondary = "#E3CCBC";
const colorTiles = ["#E3CCBC", "#E3CCBC", "#E3CCBC"];
exports.default = {
    mainInfoLandscape,
    mainInfoPortrait,
    headerTextColor,
    brand,
    headerBackgroundColor,
    appAccentColor,
    style,
    colorAppBar,
    colorOnAppBar,
    colorPrimary,
    colorPrimaryDarker,
    colorPrimaryLighter,
    colorOnPrimary,
    colorSecondary,
    colorOnSecondary,
    colorTiles,
};
